export default [
  {
    key: 'id',
    type: 'id',
    visibility: ['view'],
  },
  {
    key: 'poster',
    label: 'Poster',
    type: 'image',
    visibility: ['view'],
  },
  {
    key: 'name',
    label: 'Judul',
    visibility: ['view'],
  },
  {
    key: 'code',
    label: 'CODE',
  },
  {
    key: 'type',
    label: 'Tipe Potongan',
    type: 'badge',
    translationPrefix: 'voucher.',
    map: {
      regular: 'primary',
      shipping: 'success',
    },
    filter: {
      key: 'type',
      type: 'select',
      label: 'Tipe Potongan',
      options: [
        { value: 'regular', text: 'Produk' },
        { value: 'shipping', text: 'Ongkir' },
      ],
    },
  },
  {
    key: 'discount',
    label: 'Diskon',
    suffix: ' %',
  },
  {
    key: 'max_discount',
    label: 'Maks. Diskon',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'minimum_transaction',
    label: 'Min. Transaksi',
    type: 'rupiah',
    prefix: 'Rp ',
    visibility: ['view'],
  },
  {
    key: 'max_usage_all',
    label: 'Kuota',
    suffix: ' kali',
  },
  {
    key: 'used',
    label: 'Digunakan',
    suffix: ' kali',
  },
  {
    key: 'is_private',
    label: 'Privat',
    filter: {
      key: 'is_private',
      type: 'select',
      label: 'Privat',
      options: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
    },
    visibility: ['view'],
  },
  {
    key: 'is_claimable',
    label: 'Dapat Diklaim',
    filter: {
      key: 'is_claimable',
      type: 'select',
      label: 'Dapat Diklaim',
      options: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
    },
    visibility: ['view'],
  },
  {
    key: 'point_required',
    label: 'Mini Poin',
    visibility: ['view'],
  },
  {
    key: 'is_active',
    label: 'Aktif',
    filter: {
      key: 'is_active',
      type: 'select',
      label: 'Status',
      options: [
        { value: true, text: 'Aktif' },
        { value: false, text: 'Tidak aktif' },
      ],
    },
  },
  {
    key: 'for_recurring_registry_owner',
    label: 'Pemilik Registry Aktif',
    visibility: ['view'],
    filter: {
      key: 'for_recurring_registry_owner',
      type: 'select',
      label: 'Pemilik Registry Aktif',
      options: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
    },
  },
  {
    key: 'exclude_mos',
    label: 'Selain MOS',
    visibility: ['view'],
    filter: {
      key: 'exclude_mos',
      type: 'select',
      label: 'Selain MOS',
      options: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
    },
  },
]
